﻿import * as React from "react";
import { INotification, NotificationManager } from "../../Managers";

export const NotificationDisplay: React.FunctionComponent<INotification> = (
    props,
): React.ReactElement => {
    const constructLink = (): React.ReactNode => {
        let hrefPreFix: string;

        switch (props.linkType) {
            case `Email`:
                hrefPreFix = `mailto:`;
                break;
            case `Hyperlink`:
                // Check if link has hrefPrefix already
                hrefPreFix = props.linkURL.startsWith(`https://`)
                    ? ``
                    : `https://`;
                break;
            default:
                hrefPreFix = ``;
                break;
        }

        const linkHREF = `${hrefPreFix}${props.linkURL}`,
            linkNode: React.ReactNode = (
                <a
                    className={`content contentblock-link`}
                    href={linkHREF}
                    onClick={onLinkClick}
                    target={`_blank`}
                >
                    {props.linkText}
                </a>
            );

        return linkNode;
    };

    /**
     * Used to track which users have interacted with the link for a notification
     * This can be seen in SmartComms under the Analytics action for each notification
     */
    const onLinkClick = (): void => {
        NotificationManager.interactWithLink(props.id);
    };

    const priorityBall = (): JSX.Element => {
        const classname = `priorityball ${props.priority}`;

        return <div className={classname} />;
    };

    const onCloseClick = (): void => {
        NotificationManager.dismiss(props.id);
    };

    return (
        <div className={`notification-display`}>
            <div className={`center-vertical`}>{priorityBall()}</div>
            <div className={`display-horizontalcontainer`}>
                <div className={`display-contentblock`}>
                    <div className={`content contentblock-title`}>
                        {props.title}
                    </div>
                    <div className={`content contentblock-content`}>
                        {props.content}
                    </div>
                    {constructLink()}
                </div>
            </div>
            <div className={`display-closecontainer center-vertical`}>
                <img
                    className={`display-close`}
                    onClick={onCloseClick}
                    src={`/Images/CloseIcon.svg`}
                />
            </div>
        </div>
    );
};
